import styled from 'styled-components'
import colors from '../../../_constants/colors'

export const S_EmailConfirmation = styled.div`
  background-color: ${(props) => props.customColors.authBackground || colors.DEFAULT_AUTH_BACKGROUND};
  background-image: ${(props) => (props.bg ? `url(${props.bg})` : 'none')};
  background-position: center;
  background-repeat: no-repeat;
  background-size: ${(props) => props.bg_size || 'auto'};
  padding: 50px 10px;
  height: 100%;

  .content {
    background-color: white;
    padding-top: 100px;
    max-width: 800px;
    width: 100%;
    margin: 0 auto;
    border-radius: 5px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 700px) {
      flex-direction: column;
    }

    .title {
      font-size: 38px;
    }

    .email_section {
      padding-top: 30px;
      color: #9eaeb6;
      font-size: 15px;
    }

    .email {
      font-weight: bold;
      color: #2b3035;
      text-decoration: underline;
    }

    .buttons_section {
      padding-top: 20px;
      padding-bottom: 100px;
    }
  }
`
